<mat-select (selectionChange)="onChartTypeSelect($event)" [value]="selectedType">
  <mat-option *ngFor="let option of compatibleOptions" [value]="option.value">
    {{ option.label }}
  </mat-option>
</mat-select>
